import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { showFormErrors } from "utils/commonFunctions";
import { checkErrors } from "utils/TableFunctions";
import formValidation from "utils/validations";
import { initalAllHeatingCostsInputs, initalAllHeatingDeductionCostsInputs, initalAllMaintenanceInputs, initalAllRentsInputs, initialData } from "./initialInputObjects";
import { addRentSetupAction, getRentSetupDetailsAction, updateRentSetupAction } from "store/actions/rentsetupActions";

const RentsetupContainer = () => {
    const params = useParams();
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [activeIndex, setActiveIndex] = useState([])
    const [data, setData] = useState(initialData)
    const [baseRentData, setBaseRentData] = useState({ id: "", tier: "" })
    const [allRents, setAllRents] = useState([initalAllRentsInputs])

    const [maintenanceCostData, setMaintenanceCostData] = useState({ id: "", tier: "" })
    const [allMaintenaceCosts, setAllMaintenanceCosts] = useState([initalAllMaintenanceInputs])

    const [heatingData, setHeatingData] = useState({ id: "", tier: "" })
    const [allHeatingCosts, setAllHeatingCosts] = useState([initalAllHeatingCostsInputs])
    const [allHeatingDeductionCosts, setAllHeatingDeductionCosts] = useState([initalAllHeatingDeductionCostsInputs])

    const [administrativeCost, setAdministrativeCost] = useState({ id: "", tier: "", administrativeCost: "" })
    const [loading, setLoading] = useState(false)
    const { rentSetup } = useSelector((state) => state.rentSetup);

    useEffect(() => {
        if (rentSetup?.id && params?.id && rentSetup?.id == params?.id) {
            handleStateSet(rentSetup)
        } else if (params?.id) {
            getRentSetupDetails(params?.id);
        }
    }, [params?.id, rentSetup]);

    const handleChange = ({ name, value, form }) => {
        if (form === "rent") {
            const formErrors = formValidation(name, value, data);
            setData((prev) => ({ ...prev, [name]: value, formErrors }));
        } else if (form === "baseRent") {
            const formErrors = formValidation(name, value, baseRentData)
            setBaseRentData((prev) => ({ ...prev, [name]: value, formErrors }))
        } else if (form === "maintenance") {
            const formErrors = formValidation(name, value, maintenanceCostData)
            setMaintenanceCostData((prev) => ({ ...prev, [name]: value, formErrors }))
        } else if (form === "heating") {
            const formErrors = formValidation(name, value, heatingData)
            setHeatingData((prev) => ({ ...prev, [name]: value, formErrors }))
        } else if (form === "administrative") {
            const formErrors = formValidation(name, value, administrativeCost)
            setAdministrativeCost((prev) => ({ ...prev, [name]: value, formErrors }))
        }
    };

    const onSubmit = () => {
        let indexes = []

        let baseRentError = showFormErrors(baseRentData, setBaseRentData)
        const baseRents = checkErrors(allRents, setAllRents, ["number_of_tenant", "abstract_allowed_size", "net_rent", "gross_base_rent"])
        if (!baseRentError || baseRents.hasErrors) {
            indexes.push(0)
        } else {
            indexes = indexes.filter(index => index !== 0);
        }

        let maintenanceError = showFormErrors(maintenanceCostData, setMaintenanceCostData)
        const maintenanceCosts = checkErrors(allMaintenaceCosts, setAllMaintenanceCosts, ["number_of_tenant", "size", "avg_cost", "gross_cost"])
        if (!maintenanceError || maintenanceCosts.hasErrors) {
            indexes.push(1)
        } else {
            indexes = indexes.filter(index => index !== 1);
        }

        let heatingError = showFormErrors(heatingData, setHeatingData)
        const heatingCosts = checkErrors(allHeatingCosts, setAllHeatingCosts, ["size_from", "size_to", "cost_oil", "cost_gas", "cost_electricity"], [], 0, "size_from")
        const centralizedDeductions = checkErrors(allHeatingDeductionCosts, setAllHeatingDeductionCosts, ["number_of_tenant", "centralized_deduction"])
        if (!heatingError || heatingCosts.hasErrors || centralizedDeductions.hasErrors) {
            indexes.push(2)
        } else {
            indexes = indexes.filter(index => index !== 2);
        }

        let administrativeError = showFormErrors(administrativeCost, setAdministrativeCost)
        if (!administrativeError) {
            indexes.push(3)
        } else {
            indexes = indexes.filter(index => index !== 3);
        }

        setActiveIndex(indexes)
        if (
            showFormErrors(data, setData)
            && showFormErrors(baseRentData, setBaseRentData, ["id"])
            && !baseRents.hasErrors
            && showFormErrors(maintenanceCostData, setMaintenanceCostData, ["id"])
            && !maintenanceCosts.hasErrors
            && showFormErrors(heatingData, setHeatingData, ["id"])
            && !heatingCosts.hasErrors
            && !centralizedDeductions.hasErrors
            && showFormErrors(administrativeCost, setAdministrativeCost, ["id"])
        ) {
            if (params?.id) {
                dispatch(
                    updateRentSetupAction(
                        params?.id,
                        data,
                        baseRentData,
                        baseRents?.values,
                        maintenanceCostData,
                        maintenanceCosts?.values,
                        heatingData,
                        heatingCosts?.values,
                        centralizedDeductions?.values,
                        administrativeCost,
                        setLoading,
                        dispatch,
                        (res) => {
                            navigate(`/rent/view/${params?.id}`)
                        }
                    )
                )
            } else {
                dispatch(
                    addRentSetupAction(
                        data,
                        baseRentData,
                        baseRents?.values,
                        maintenanceCostData,
                        maintenanceCosts?.values,
                        heatingData,
                        heatingCosts?.values,
                        centralizedDeductions?.values,
                        administrativeCost,
                        setLoading,
                        dispatch,
                        (res) => {
                            navigate('/rent/list')
                        }
                    )
                )
            }
        }
    }

    const getRentSetupDetails = (id) => {
        dispatch(
            getRentSetupDetailsAction(id, dispatch)
        );
    };

    const handleStateSet = (info) => {
        setData({
            regulationName: info?.regulation_name,
            federalState: info?.federal_state,
            note: info?.note,
        })
        setBaseRentData({ id: info?.base_rent_cost_tier?.id, tier: info?.base_rent_cost_tier?.tier })
        setAllRents(info?.base_rent_cost_tier?.base_rent)

        setHeatingData({ id: info?.heating_rent_cost_tier?.id, tier: info?.heating_rent_cost_tier?.tier })
        setAllHeatingCosts(info?.heating_rent_cost_tier?.heating_rent)
        setAllHeatingDeductionCosts(info?.heating_rent_cost_tier?.heating_deduction)

        setMaintenanceCostData({ id: info?.maintenance_rent_cost_tier?.id, tier: info?.maintenance_rent_cost_tier?.tier })
        setAllMaintenanceCosts(info?.maintenance_rent_cost_tier?.maintenance_rent)
        setAdministrativeCost({ id: info?.administrator_cost_tier?.id, tier: info?.administrator_cost_tier?.tier, administrativeCost: info?.administrator_cost_tier?.cost })
    }

    return {
        data,
        baseRentData,
        maintenanceCostData,
        heatingData,
        administrativeCost,
        handleChange,
        loading,
        onSubmit,
        navigate,
        allRents, setAllRents,
        allMaintenaceCosts, setAllMaintenanceCosts,
        allHeatingCosts, setAllHeatingCosts,
        allHeatingDeductionCosts, setAllHeatingDeductionCosts,
        activeIndex, setActiveIndex
    }
}

export default RentsetupContainer